import gql from 'graphql-tag'

import { client } from '@operato/graphql'

export const scenarios = async (): Promise<{ name: string; description: string }[]> => {
  var response = await client.query({
    query: gql`
      query {
        scenarios {
          items {
            name
            description
          }
        }
      }
    `
  })

  if (response.errors) {
    return []
  }

  return response.data.scenarios.items
}

export const startScenario = async (
  scenarioName: string,
  instanceName: string,
  variables: string | number | object
) => {
  if (!scenarioName) {
    return
  }

  if (client) {
    var response = await client.query({
      query: gql`
        mutation ($instanceName: String, $scenarioName: String!, $variables: Object) {
          startScenario(instanceName: $instanceName, scenarioName: $scenarioName, variables: $variables) {
            state
            message
            data
          }
        }
      `,
      variables: {
        instanceName: instanceName,
        scenarioName: scenarioName,
        variables
      }
    })

    return response?.data?.startScenario?.data
  }
}

export const runScenario = async (scenarioName: string, variables: string | number | object) => {
  if (!scenarioName) return

  if (client) {
    var response = await client.query({
      query: gql`
        mutation ($scenarioName: String!, $variables: Object) {
          runScenario(scenarioName: $scenarioName, variables: $variables) {
            state
            message
            data
          }
        }
      `,
      variables: {
        scenarioName: scenarioName,
        variables
      }
    })

    return response?.data?.runScenario?.data
  }
}
